import React, { useCallback } from 'react';
import Header from './Header';
import Footer from './Footer';
import HeroSection from './home/HeroSection';
import LogoCloud from './home/LogoCloud';
import WhyHTML5Section from './home/WhyHTML5Section';
import StorySections from './home/StorySections';
import ValueProposition from './home/ValueProposition';
import IndustriesSection from './home/IndustriesSection';
import CTASection from './home/CTASection';
import { useCMSContent } from '@/hooks/use-cms-content';
import { fetchHomeSections } from '@/lib/cms';

const AppLayout: React.FC = () => {
  const fetchFn = useCallback(() => fetchHomeSections(), []);
  const { data: cms } = useCMSContent('home-sections', fetchFn, {} as Record<string, Record<string, unknown>>);

  return (
    <div className="min-h-screen bg-white dark:bg-[#0a0a0f]">
      <Header />
      <main>
        <HeroSection cmsData={cms.hero} />
        {/* TODO: LogoCloud needs work — re-enable once publisher logos and layout are polished */}
        {/* <LogoCloud cmsData={cms.logo_cloud} /> */}
        <WhyHTML5Section />
        <StorySections cmsData={{ create: cms.story_create, deliver: cms.story_deliver, measure: cms.story_measure }} />
        <ValueProposition cmsData={cms.value_props} />
        <IndustriesSection cmsData={cms.industries} />
        <CTASection cmsData={cms.cta} />
      </main>
      <Footer />
    </div>
  );
};

export default AppLayout;
